import { Grid } from '@mui/material';

import { SearchField, SubHeader } from '@components';

export function BeneficiaryServicesHeader() {
  return (
    <SubHeader>
      <Grid spacing={3} container item alignItems="center">
        <Grid item xs={12}>
          <SearchField placeholder="Buscar por nº da carteirinha, nome completo ou CPF" />
        </Grid>
      </Grid>
    </SubHeader>
  );
}
